var map = {
	"./pic1.jpg": 190,
	"./pic2.jpg": 191,
	"./pic3.jpg": 192,
	"./pic4.jpg": 193,
	"./pic5.jpg": 194,
	"./pic6.jpg": 195,
	"./pic7.jpg": 196,
	"./pic8.jpg": 197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 533;